(function ManagerMapAmenitiesForm($, HE)
{
	"use strict";

	var form = {
		name: 'MapAmenities',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.mapped-unmapped').change(function checkChange() {
			toggleMasterAmenity();
		});

		$('.amenity-check').change(function checkChange() {
			var checked_count = 0;

			$('.amenity-check').each(function checkedCheck() {
				if ($(this).is(':checked')) {
					checked_count++;
					return;
				}
			});

			if (checked_count > 0) {
				$('.master-amenity').prop('disabled', false);
				$('#save-button').removeClass('disabled');
			} else {
				$('.master-amenity').prop('disabled', true);
				$('#save-button').addClass('disabled');
			}
		});
	};

	function toggleMasterAmenity()
	{
		var mapped  = $('.mapped-unmapped').val(),
		    $row    = $('.master-amenity-row'),
		    $select = $('.search-master-amenity');

		if (mapped === '0') {
			$select.prop('disabled', true);
			$row.addClass('d-none');
		} else {
			$select.prop('disabled', false);
			$row.removeClass('d-none');
		}
	}
}(jQuery, window.HE || {}));
